import React from "react";
import {
	BrowserRouter as Router,
	Routes,
	Route,
	Navigate,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Dashboard } from "./admin/pages/Dashboard";
import { Login } from "./admin/pages/Login";
import { ForgotPassword } from "./admin/pages/ForgotPassword";
import { ResetPassword } from "./admin/pages/ResetPassword";
import { Profile } from "./admin/pages/Profile";
import { ChangePassword } from "./admin/pages/ChangePassword";

import { RolesList } from "./admin/pages/roles/RolesList";
import { RoleForm } from "./admin/pages/roles/RoleForm";

import { SkillsList } from "./admin/pages/skills/SkillsList";
import { SkillForm } from "./admin/pages/skills/SkillForm";

import { CategoriesList } from "./admin/pages/categories/CategoriesList";
import { CategoryForm } from "./admin/pages/categories/CategoryForm";

import { ResourcesList } from "./admin/pages/resources/ResourcesList";
import { ResourceForm } from "./admin/pages/resources/ResourceForm";
import { RatesList } from "./admin/pages/rates/RatesList";
import { RateForm } from "./admin/pages/rates/RateForm";
import { ContactsList } from "./admin/pages/contacts/ContactsList";
import { ContactView } from "./admin/pages/contacts/ContactView";
import { InquiriesList } from "./admin/pages/inquiries/InquiriesList";
import { InquiryView } from "./admin/pages/inquiries/InquiryView";
import Home from "./public/pages/Home";
import ResourceDetail from "./public/pages/ResourceDetail";
import ResourceDirectory from "./public/pages/ResourceDirectory";
import SkillMatrix from "./public/pages/SkillMatrix";
import Contact from "./public/pages/Contact";
import Inquiry from "./public/pages/Inquiry";
import VerifyInquiry from "./public/pages/VerifyInquiry";

function App() {
	return (
		<Router>
			<AuthProvider>
				<ToastContainer
					position="top-right"
					autoClose={3000}
					hideProgressBar={false}
					newestOnTop={true}
					closeOnClick
					pauseOnHover
					draggable
				/>

				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/resources" element={<ResourceDirectory />} />
					<Route path="/resources/:id" element={<ResourceDetail />} />
					<Route path="/skill-matrix" element={<SkillMatrix />} />
					<Route path="/contact" element={<Contact />} />
					<Route path="/inquiry" element={<Inquiry />} />
					<Route path="/inquiry/verify" element={<VerifyInquiry />} />

					{/* Auth Routes */}
					<Route path="/admin/login" element={<Login />} />
					<Route path="/admin/forgot-password" element={<ForgotPassword />} />
					<Route path="/admin/reset-password" element={<ResetPassword />} />

					{/* Admin Dashboard */}
					<Route
						path="/admin"
						element={
							<ProtectedRoute>
								<Dashboard />
							</ProtectedRoute>
						}
					/>

					{/* Admin Routes */}
					<Route
						path="/admin/profile"
						element={
							<ProtectedRoute>
								<Profile />
							</ProtectedRoute>
						}
					/>
					<Route
						path="/admin/change-password"
						element={
							<ProtectedRoute>
								<ChangePassword />
							</ProtectedRoute>
						}
					/>

					{/* Roles */}
					<Route
						path="/admin/roles"
						element={
							<ProtectedRoute>
								<RolesList />
							</ProtectedRoute>
						}
					/>
					<Route
						path="/admin/roles/:id"
						element={
							<ProtectedRoute>
								<RoleForm />
							</ProtectedRoute>
						}
					/>

					{/* Skills */}
					<Route
						path="/admin/skills"
						element={
							<ProtectedRoute>
								<SkillsList />
							</ProtectedRoute>
						}
					/>
					<Route
						path="/admin/skills/:id"
						element={
							<ProtectedRoute>
								<SkillForm />
							</ProtectedRoute>
						}
					/>

					{/* Categories */}
					<Route
						path="/admin/categories"
						element={
							<ProtectedRoute>
								<CategoriesList />
							</ProtectedRoute>
						}
					/>
					<Route
						path="/admin/categories/:id"
						element={
							<ProtectedRoute>
								<CategoryForm />
							</ProtectedRoute>
						}
					/>

					{/* Resources */}
					<Route
						path="/admin/resources"
						element={
							<ProtectedRoute>
								<ResourcesList />
							</ProtectedRoute>
						}
					/>
					<Route
						path="/admin/resources/:id"
						element={
							<ProtectedRoute>
								<ResourceForm />
							</ProtectedRoute>
						}
					/>

					{/* Rates */}
					<Route
						path="/admin/rates"
						element={
							<ProtectedRoute>
								<RatesList />
							</ProtectedRoute>
						}
					/>
					<Route
						path="/admin/rates/:id"
						element={
							<ProtectedRoute>
								<RateForm />
							</ProtectedRoute>
						}
					/>

					{/* Contacts */}
					<Route
						path="/admin/contacts"
						element={
							<ProtectedRoute>
								<ContactsList />
							</ProtectedRoute>
						}
					/>
					<Route
						path="/admin/contacts/:id"
						element={
							<ProtectedRoute>
								<ContactView />
							</ProtectedRoute>
						}
					/>

					{/* Inquiries */}
					<Route
						path="/admin/inquiries"
						element={
							<ProtectedRoute>
								<InquiriesList />
							</ProtectedRoute>
						}
					/>
					<Route
						path="/admin/inquiries/:id"
						element={
							<ProtectedRoute>
								<InquiryView />
							</ProtectedRoute>
						}
					/>

					{/* Fallback */}
					<Route path="*" element={<Navigate to="/" />} />
				</Routes>
			</AuthProvider>
		</Router>
	);
}

export default App;
